module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_6005.d67bbc96.png";